import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  spFreelancerRegistrationForthStepValid: false,
  spFreelancerRegistrationCompanyRecommendationInfo: { recommendations: [] },
  spFreelancerRegistrationCompanySocialNetworkLinkInfo: {},
  spFreelancerRegistrationCompanyIpAddressInfo: {},
  spFreelancerRegistrationCompanyCertificationInfo: {},
  spFreelancerRegistrationEmailVerificationInfo: {},
  spFreelancerClientInfo: {},
  spFreelancerServicesInfo: {},
  spFreelancerRegistrationCurrentStep: 1,
  spFreelancerRegistrationVisitedStepsCnt: 1,
  spFreelancerRegistrationFilledStepsCnt: 0,
  spFreelancerLoading: {},
  spFreelancerLoadingErrors: {},
  spFreelancerRecaptchaToken: null,
  spFreelancerEmailVerificationSent: false,
  spFreelancerClientAvatar: null,
  spFreelancerServices: [],
  spFreelancerCertificates: [],
};

export default {
  state,
  getters,
  mutations,
  actions,
};
